import { isNativePlatform } from "@/lib/native";

// Public, scannable origin: the native WebView origin (capacitor://localhost) is not reachable by phone cameras.
export function publicOrigin() {
  const o = window.location.origin || "";
  return /^https?:\/\//.test(o) && !isNativePlatform() ? o : process.env.REACT_APP_BACKEND_URL;
}

const esc = (s) => String(s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

// iOS (native WebView) cannot open print windows: use the system share sheet (Print / Save Image / AirDrop).
export async function shareOrPrintQr({ canvasId, title, subtitle, fileName = "caterctrl-qr.png" }) {
  const canvas = document.getElementById(canvasId);
  if (!canvas) return "missing";
  const dataUrl = canvas.toDataURL("image/png");
  const blob = await (await fetch(dataUrl)).blob();
  const file = new File([blob], fileName, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], title: title || "CaterCTRL QR" }); return "shared"; }
    catch (e) { if (e?.name === "AbortError") return "cancelled"; }
  }
  const w = !isNativePlatform() && window.open("", "_blank", "width=420,height=600");
  if (w) {
    w.document.write(`<html><head><title>${esc(title)}</title></head><body style="text-align:center;font-family:sans-serif;padding:24px">
      <h2>${esc(title)}</h2><p>${esc(subtitle)}</p><img src="${dataUrl}" style="width:280px;height:280px"/>
      <p style="font-size:12px;color:#888">Scan with a phone camera</p></body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 300);
    return "printed";
  }
  const a = document.createElement("a");
  a.href = dataUrl; a.download = fileName; document.body.appendChild(a); a.click(); a.remove();
  return "downloaded";
}
